import { useQuery } from "@tanstack/react-query";
import { TransactionResponse, WalletService } from "@/services/wallet.service";
import { useTranslation } from "react-i18next";

export const useFetchTransactions = ({
  currentPage,
  q,
  status,
  startDate,
  endDate,
  enabled = true,
  currency,
}: {
  currentPage?: number;
  q?: string;
  status?: string;
  startDate?: string;
  endDate?: string;
  enabled?: boolean;
  currency?: string;
}) => {
  const { t } = useTranslation('common');
  const {
    data: transactions,
    isPending: isLoading,
    refetch,
    isRefetching,
    error,
  } = useQuery<TransactionResponse>({
    queryKey: [
      'wallet-transactions',
      currentPage,
      q,
      status,
      startDate,
      endDate,
      currency,
    ],
    queryFn: async () =>
      await WalletService.getTransactions({
        currentPage,
        q,
        status,
        startDate,
        endDate,
        currency,
      }),
    enabled,
  });

  return {
    transactions,
    isLoading,
    refetch,
    isRefetching,
    error: error ? (error as Error).message || t('data_listing_error') : null,
  };
};
